import { Button, Container, Group, Paper, Stack, Text, ThemeIcon, Title } from '@mantine/core';
import { ShieldX } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function AccessDenied() {
  const { t } = useTranslation('common');

  return (
    <Container size="sm" py="xl" style={{ minHeight: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Paper withBorder radius="lg" p="xl" shadow="sm" w="100%">
        <Stack align="center" gap="md" ta="center">
          <ThemeIcon size={72} radius="xl" variant="light" color="red">
            <ShieldX size={40} />
          </ThemeIcon>
          <Text fw={800} size="64px" lh={1} c="red.6">
            403
          </Text>
          <Title order={1} size="h2">
            {t('accessDeniedPage.title')}
          </Title>
          <Text c="dimmed" maw={460}>
            {t('accessDeniedPage.description')}
          </Text>
          <Group justify="center" mt="sm">
            <Button component={Link} to="/dashboard" size="md">
              {t('accessDeniedPage.backToDashboard')}
            </Button>
          </Group>
        </Stack>
      </Paper>
    </Container>
  );
}

export default AccessDenied;